import TopOrganizations from '@/pages/dashboard/components/TopOrganizations';
import { IconType } from '@/ui';
import dashboardStyles from '../../dashboard/styles.module.css';
import GeneralCustomersCard from '@/components/CustomerCard/CustomerCard';
import { Column } from '@/components/SettingsLayout';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  useGetDashboardMetricsQuery,
  useGetTopCompaniesQuery,
} from '@/store/slices/dashboardSlice';
import { skipToken } from '@reduxjs/toolkit/query';
import { OrderMetricBy, TopMetricParams } from '@/services/Dashboard/dashboard.service';
import { TimePeriod } from '@/services/Dashboard/dashboard.service';
import useFormatNumber from '@/hooks/useFormatNumber';
import { useState } from 'react';

import { CompanyTypes } from '@/types';

export const OrganizationDashboard = () => {
  const { id } = useParams();

  const defaultMetricQuery: TopMetricParams = {
    timePeriod: TimePeriod.ALL_TIME,
    sortBy: OrderMetricBy.TOTAL_PAYMENT_VOLUME,
  };
  const metricQuery = {
    companyId: id!,
    orgDateRange: TimePeriod.ALL_TIME,
    companyDateRange: TimePeriod.ALL_TIME,
    orgOrder: OrderMetricBy.TOTAL_PAYMENT_VOLUME,
    companyOrder: OrderMetricBy.TOTAL_PAYMENT_VOLUME,
    organizationId: id!,
  };
  const [filter, setFilter] = useState<TopMetricParams>(defaultMetricQuery);
  const { data: metrics } = useGetDashboardMetricsQuery(id ? metricQuery : skipToken);
  const { data: top_companies } = useGetTopCompaniesQuery(
    id ? { id, organizationId: id, filter } : skipToken,
  );
  const { t } = useTranslation();
  const formatNumber = useFormatNumber();

  const handleFilterChange = (name: keyof TopMetricParams, value: any) => {
    setFilter((prevState) => {
      return { ...prevState, [name]: value };
    });
  };
  return (
    <Column gapSize='24'>
      <div className={`${dashboardStyles.cardGrid}`}>
        <div className={dashboardStyles.purpleSvg}>
          <GeneralCustomersCard
            title={t('Dashboard.total_companies')}
            comment={t('Dashboard.total')}
            data={`${metrics?.numberOfCompanies ?? 0}`}
            icon={{
              type: IconType.Bag,
              width: 56,
            }}
          />
        </div>
        <div className={dashboardStyles.orangeSvg}>
          <GeneralCustomersCard
            title={t('Dashboard.transaction_count')}
            comment={t('Dashboard.total_payment_volume_comment')}
            data={formatNumber(metrics?.totalTransaction ?? 0, undefined, 0)}
            icon={{
              type: IconType.Building,
              width: 56,
            }}
          />
        </div>
        <div className={dashboardStyles.tealSvg}>
          <GeneralCustomersCard
            title={t('Dashboard.total_payment_volume')}
            comment={t('Dashboard.total_payment_volume_comment')}
            data={formatNumber(metrics?.totalPaymentVolume ?? 0)}
            icon={{
              type: IconType.Coin,
              width: 56,
            }}
          />
        </div>
      </div>
      <TopOrganizations<TopMetricParams>
        title={'Dashboard.top_companies'}
        data={top_companies}
        onFilterChange={handleFilterChange}
        dateRangeKey={'timePeriod'}
        sortKey={'sortBy'}
        entityType={CompanyTypes.COMPANY}
      />
    </Column>
  );
};
